import React , {Component} from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

class LeaveMessage extends Component {

  constructor(props) {
      super(props)
  }

  render () {
    return (
     
        <div onClick={() => window.zE.activate()} className='leave-message--container' style={{position: 'fixed', right: '0', top: '30vh', zIndex: '10', background: '#404041', 
        textTransform: 'uppercase', color: '#fff', writingMode: 'vertical-lr', padding: '15px 0 0 0', 
        fontSize: '11px', letterSpacing: '0.1rem', fontWeight: '700', cursor: 'pointer'}}>
          <span style={{paddingBottom: '10px'}}>Leave Us a Message</span>
          <div style={{display: 'inline-block', height: '42px', width: '42px', background: 'linear-gradient(to right, #ee836f, #fc7178, #ff5d8a, #ff4aa4, #ff3fc5)'}}>
            <img src='img/leave-message.png' style={{width: '42px'}} />
          </div>
        </div>
    )
  }
}

const mapStateToProps = ( state, props ) => ({

})

const mapDispatchToProps ={

    }

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LeaveMessage)


// WEBPACK FOOTER //
// ./src/components/landing/LeaveMessage.js